export const ROUTE_STEP_MAPPING: Record<string, number> = {
  "ingresar-datos": 1,
  "verificar-identidad": 2,
  "validacion-exitosa": 3,
};

export const OTP_ROUTE_STEP_MAPPING: Record<string, number> = {
  "elegir-canal": 2,
  "validar-codigo": 3,
};

export const OTP_TOTAL_STEPS = 3;

export const RECOVERY_RESULT_SEGMENT = "validacion-exitosa";
